export default {
notification: {
  read: "پڑھ لیا گیا",
  unread: "غیر پڑھے ہوئے",
  hide: "چھپائیں",
  showAll: "سب دکھائیں",
  loading: "لوڈ ہو رہا ہے...",
  noMore: "مزید ڈیٹا نہیں",
  platform: "پلیٹ فارم",
  personal: "ذاتی"
}
};
